export default __webpack_public_path__ + "static/media/path4.cb1d9fab.png";